import React, { useEffect } from "react";
import Routes from "navRoutes/Routes";

const App = () => {
	useEffect(() => {
        if(window.localStorage.getItem("account")) {
        } else {
            window.localStorage.setItem("account", false);
		}
    }, [])

	return (
		<>
			<Routes />
		</>
	);
};

export default App;
